/**
 * @fileoverview added by tsickle
 * Generated from: src/zone-helpers.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright DagonMetric. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found under the LICENSE file in the root directory of this source tree.
 */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { queueScheduler } from 'rxjs';
export class ZoneScheduler {
    /**
     * @param {?} zone
     * @param {?=} delegate
     */
    constructor(zone, delegate = queueScheduler) {
        this.zone = zone;
        this.delegate = delegate;
    }
    /**
     * @return {?}
     */
    now() {
        return this.delegate.now();
    }
    // eslint-disable-next-line no-shadow
    /**
     * @param {?} work
     * @param {?=} delay
     * @param {?=} state
     * @return {?}
     */
    schedule(work, delay, state) {
        /** @type {?} */
        const targetZone = this.zone;
        /** @type {?} */
        const workInZone = (/**
         * @this {?}
         * @param {?} stateLocal
         * @return {?}
         */
        function (stateLocal) {
            targetZone.runGuarded((/**
             * @return {?}
             */
            () => {
                work.apply(this, [stateLocal]);
            }));
        });
        return this.delegate.schedule(workInZone, delay, state);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    ZoneScheduler.prototype.zone;
    /**
     * @type {?}
     * @private
     */
    ZoneScheduler.prototype.delegate;
}
//# sourceMappingURL=zone-helpers.js.map